module.exports = __webpack_public_path__ + "static/img/logo.110fdb52.svg";